/* About media — muted inline loop video with a pause/play control.
   Plays only while in view, never auto-starts under prefers-reduced-motion,
   and cleans up on theme-editor section unload (disconnectedCallback). */

if (!customElements.get('about-media-video')) {
  class AboutMediaVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-video-toggle]');
      if (!this.video) return;

      this.video.muted = true;
      this.video.loop = true;
      this.video.playsInline = true;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userPaused = reduceMotion;
      this.inView = false;

      this.onPlaying = () => {
        this.classList.add('has-started');
        this.sync();
      };
      this.onPause = () => this.sync();
      this.onToggle = () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      };

      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('pause', this.onPause);
      if (this.toggle) this.toggle.addEventListener('click', this.onToggle);

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.inView = entry.isIntersecting;
            if (this.inView && !this.userPaused) {
              this.play();
            } else if (!this.inView && !this.video.paused) {
              this.video.pause();
            }
          });
        },
        { threshold: 0.1 }
      );
      this.observer.observe(this);
      this.sync();
    }

    disconnectedCallback() {
      if (!this.video) return;
      this.video.removeEventListener('playing', this.onPlaying);
      this.video.removeEventListener('pause', this.onPause);
      if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
      if (this.observer) this.observer.disconnect();
      this.video.pause();
    }

    play() {
      const attempt = this.video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(() => this.sync());
      }
    }

    sync() {
      const playing = !this.video.paused;
      this.classList.toggle('is-playing', playing);
      if (this.toggle) {
        this.toggle.setAttribute('aria-label', playing ? this.dataset.labelPause : this.dataset.labelPlay);
      }
    }
  }

  customElements.define('about-media-video', AboutMediaVideo);
}
